import React, { useState } from "react";
import {
  Divider,
  Alert,
  Row,
  Col,
  Space,
  Button,
  message,
  Popconfirm,
  Typography,
} from "antd";
import DeleteUser from "@general/deleteUser";
import DeactivateUser from "@general/deactivateUser";
import { gql, useMutation } from "@apollo/client";
import ActivateUser from "@general/activateUser";

const CHANGEUSERROLE = gql`
  mutation updateUser($id: ID!, $updateUserInput: UpdateUserInput!) {
    updateUser(updateInput: $updateUserInput, id: $id)
  }
`;

function UserSetting({
  id,
  name,
  confirmStatus,
  confirmMessage,
  createdAt,
  updatedAt,
  onDoUpdateUser,
  userRole,
  closeDrawer,
  deactivatedAt,
}) {
  const newRole = userRole === "ADMIN" ? "USER" : "ADMIN";

  const [runChangeUserRole, changeUserRole] = useMutation(CHANGEUSERROLE, {
    onCompleted() {
      message.success(
        `دسترسی ${name} به ${newRole === "ADMIN" ? "مدیر" : "کاربر"} تغییر کرد.`
      );
      onDoUpdateUser();
      closeDrawer();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده! سطح دسترسی کاربر تغییر نکرد.");
    },
  });
  const doChangeUserRole = () => {
    runChangeUserRole({
      variables: {
        id,
        updateUserInput: {
          userRole: newRole,
        },
      },
    });
  };
  const { Text } = Typography;
  return (
    <div>
      {confirmStatus && (
        <>
          <Divider orientation="right">وضعیت</Divider>
          <Row>
            <Col span={24}>
              <Alert
                message={
                  confirmStatus === "SUCCESS"
                    ? "تایید شده"
                    : confirmStatus === "ERROR"
                    ? "رد شده"
                    : "در انتظار"
                }
                description={
                  confirmMessage
                    ? confirmMessage
                    : "پیامی برای کاربر ارسال نشده."
                }
                type={
                  confirmStatus === "SUCCESS"
                    ? "success"
                    : confirmStatus === "ERROR"
                    ? "error"
                    : "warning"
                }
                showIcon
              />
            </Col>
          </Row>
          <Divider orientation="right">سطح کاربر</Divider>
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>
              سطح کاربر:{" "}
              <Text type="success" strong>
                {userRole === "USER" ? "کاربر" : "مدیر"}
              </Text>
            </span>

            <Popconfirm
              title={
                userRole === "ADMIN"
                  ? `تغییر به کاربر`
                  : `ارتقا ${name} به مدیر؟`
              }
              okText="بله"
              cancelText="خیر"
              onConfirm={doChangeUserRole}
            >
              <Button type="primary">تغییر</Button>
            </Popconfirm>
          </Row>
        </>
      )}
      <Divider orientation="right">اکانت</Divider>
      <Row
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Space direction="vertical">
          <p>تاریخ ثبت نام: {createdAt}</p>

          <p> آخرین بروزرسانی: {updatedAt ? updatedAt : "-"}</p>
        </Space>
        <Space direction="horizontal">
          {!deactivatedAt ? (
            <DeactivateUser
              id={id}
              name={name}
              onDeactivateUser={() => {
                onDoUpdateUser();
                closeDrawer();
              }}
            >
              <Button danger>غیرفعال کردن</Button>
            </DeactivateUser>
          ) : (
            <ActivateUser
              id={id}
              name={name}
              onActivateUser={() => {
                onDoUpdateUser();
                closeDrawer();
              }}
            >
              <Button success>فعال کردن</Button>
            </ActivateUser>
          )}

          <DeleteUser
            id={id}
            name={name}
            onDeleteUser={() => {
              onDoUpdateUser();
              closeDrawer();
            }}
          >
            {confirmStatus != "SUCCESS" && (
              <Button type="primary" danger>
                حذف کاربر
              </Button>
            )}
          </DeleteUser>
        </Space>
      </Row>
    </div>
  );
}

export default UserSetting;
